<template>
	<div class="main">
		
		<router-link to="/" title="What I Ate! Home"> 
			<div class="link_box wi8_font"> 

				<div class="title">
					Page not found
				</div>

				<div class="url narrow_font">
					{{$route.path}}
				</div>
				
				<UniIcon 
					ico="logo_da"
					w="128"
					h="128"
				/>

				<br/>
				Return to What I Ate!

			</div>
		</router-link>




	</div>
</template>

<script>
export default {
}
</script>

<style scoped>
	.main {
		height: 100%;
		overflow: hidden;
		background-color: #FCF3F3;
		padding: 20px;
		border: solid 0px #090;
	}
	a {
		color: #666;
		text-decoration: none;
	}
	.title {
		height: 40px;
		color: #C30;
		border: solid 0px #369;
	}
	.url {
		height: 60px;
		overflow: hidden;
		color: #C30;
		border: solid 0px #369;
	}
	.link_box {
		height: 100%;
		overflow: hidden;
		color: #369;
		text-align: center;
		border: solid 0px #C30;
	}
</style>
